import {fromEvent} from "rxjs";
import {tap} from "rxjs/operators";
import {disableScroll, enableScroll} from "./lib/enable-disable-scroll";

let panelVars = { $headEl: jQuery('#wrapper-navbar')};

export const initBookingPanel = () => {

    //let $head = jQuery('#wrapper-navbar')

    fromEvent(jQuery('.book-now'), 'click').pipe(
        tap(e => {
            //disableScroll();
            panelVars.$headEl.addClass('booking-panel-open');

        })
    ).subscribe();
    fromEvent(jQuery('.close-book-now'), 'click').pipe(
        tap(e => {
            // enableScroll();
            panelVars.$headEl.removeClass('booking-panel-open');
        })
    ).subscribe();


}
export const showBookingPanel = () => {
    panelVars.$headEl.addClass('booking-panel-open');
}
export const hideBookingPanel = () => {
    panelVars.$headEl.removeClass('booking-panel-open');
}